import { combineReducers } from 'redux';
import authReducer from "./authReducer.js";
import monitoreoReducer from './monitoreoReducer.js';
import guiasUnidadReducer from './guiasUnidadReducer.js';
import versionReducer from './versionReducer.js';
import catalogoSucursalReducer from './catalogoSucursalReducer.js';
import gestionPaquetesReducer from './gestionPaquetesReducer.js';
import recoleccionReducer from './recoleccionesReducer.js';
import dashboardReducer from './dashboardReducer.js';
import tableroControlReducer from './tableroControlReducer.js';
import autorizarReducer from './autorizarReducer.js';

const appReducer = combineReducers({
    authentication:     authReducer,
    monitoreo:          monitoreoReducer,
    guiasunidad:        guiasUnidadReducer,
    version:            versionReducer,
    catalogosucursal:   catalogoSucursalReducer,
    gestionPaquetes:    gestionPaquetesReducer,
    recolecciones:      recoleccionReducer,
    dashboard:          dashboardReducer,
    tableroControl:     tableroControlReducer,
    autorizar:          autorizarReducer,
});

// Al cerrar sesion se resetean TODOS los slices de vista a su estado inicial
// (mensajes de error tipo "Acceso denegado", excels pendientes, listados) para
// que no contaminen la siguiente sesion. Se conserva authentication: su propio
// case LOGOUT_SUCCESS limpia el token y el localStorage (su initState se evalua
// al cargar el modulo, por lo que resetearlo a undefined re-viviria el token viejo).
const rootReducer = (state, action) => {
    if (action.type === 'LOGOUT_SUCCESS' && state) {
        state = { authentication: state.authentication };
    }
    return appReducer(state, action);
};

export default rootReducer;
